import { render, staticRenderFns } from "./Spotindex.vue?vue&type=template&id=3b6b4b72&"
import script from "./Spotindex.vue?vue&type=script&lang=js&"
export * from "./Spotindex.vue?vue&type=script&lang=js&"
import style0 from "./Spotindex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports